module.exports = __webpack_public_path__ + "c082a3d47367cff2b54bc7dc40f878a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/games/Dawn-of-War-II.jpg
// module id = 448
// module chunks = 0